import { render, staticRenderFns } from "./OzIcon.vue?vue&type=template&id=df9ea424&scoped=true&"
import script from "./OzIcon.vue?vue&type=script&lang=ts&"
export * from "./OzIcon.vue?vue&type=script&lang=ts&"
import style0 from "./OzIcon.vue?vue&type=style&index=0&id=df9ea424&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9ea424",
  null
  
)

export default component.exports